import * as React from 'react'
import MDSpinner from 'react-md-spinner'

interface ISpinnerProps {
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const InlineSpinner: React.FunctionComponent<ISpinnerProps> = (props) => (
  <MDSpinner size={props.size} className={`tc-spinner ${props.className}`} style={props.style} />
)
